export const format = [
    { text: '필요없음', value: '' },
    { text: '전용서식', value: 'format' },
]

export const count = [
    { text: '하루 3회', value: 'day3', disabled: true},
    { text: '하루 2회', value: 'day2' , disabled: true},
    { text: '하루 1회', value: 'day1', disabled: true},
    { text: '조금씩 나누어', value: 'little', disabled: true},
    { text: '점심과 저녁', value: 'lunchAndDinner', disabled: true},
    { text: '아침과 저녁', value: 'morningAndEvening', disabled: true},
    { text: '기타', value: 'etc', disabled: true},
]

export const time = [
    { text: '식사 무관하게', value: 'irrelevant', disabled: true},
    { text: '식전 30분 ~ 1시간', value: 'beforeMeal30m1h', disabled: true},
    { text: '식후 30분 ~ 1시간', value: 'afterMeal30m1h', disabled: true},
    { text: '식후 10분', value: 'afterMeal10m', disabled: true},
    { text: '공복에', value: 'spandrel', disabled: true},
    { text: '기타', value: 'etc', disabled: true},
]

export const temperature = [
    { text: '무관하게', value: 'irrelevant', disabled: true},
    { text: '실온 상태로', value: 'roomTemperature', disabled: true},
    { text: '차갑게', value: 'coldly', disabled: true},
    { text: '따뜻하게', value: 'warmly', disabled: true},
]

export const forbidden = [
    { text: '술', value: 'alcohol', disabled: true},
    { text: '돼지고기', value: 'pork', disabled: true},
    { text: '닭고기', value: 'chicken', disabled: true},
    { text: '밀가루 음식', value: 'flour', disabled: true},
    { text: '커피', value: 'coffee', disabled: true},
    { text: '탄산음료', value: 'carbonated', disabled: true},
    { text: '녹두', value: 'greenGram', disabled: true},
    { text: '단 음식', value: 'sweet', disabled: true},
    { text: '기름진 음식', value: 'stodge', disabled: true},
    { text: '매운음식', value: 'spicy', disabled: true},
    { text: '기타', value: 'etc', disabled: true},
]